export const SALUDO = "Hola";
export const DATAGRID_PRODUCTOS_PAC = {
    module: "DGL-PRODUCTS_PAC",
    description: "DataList de Productos PAC"
}
export const DATAGRID_PRODUCTOS = {
    module: "DGL-PRODUCTS",
    description: "DataList de Productos"
}
export const DATAGRID_DIRECTORY = {
    module: "DGL-DIRECTORY",
    description: "DataList de Directorio"
}
export const DATAGRID_COTIZACIONES = {
    module: "DGL-QUOTES",
    description: "DataList de Cotizaciones"
}
